<template>
  <div class="login-container">
    <div
      class="content"
    >
      <FuncionalidadeHeader
        :info="false"
        :login="true"
        :titulo="loginData.parametros.textos.tituloNavegacao"
        :voltar="false"
      >
      </FuncionalidadeHeader>
      <p
        v-if="loginData.parametros.textos.cabecalho"
        class="login-cabecalho"
      >
        {{ loginData.parametros.textos.cabecalho }}
      </p>

      <div
        id="form-render"
      />

      <p
        v-if="loginData.parametros.textos.rodape"
        class="login-rodapé"
      >
        {{ loginData.parametros.textos.rodape }}
      </p>
      <AlertaErro
        v-model="erro.show"
        :description="erro.descricao"
        :title="erro.titulo"
      />
      <termo-de-uso-combobox
        ref="termoBox"
        :id-termo="idTermo"
        v-model="checked"
      />
      <ButtonDefault
        :disabled="!checked"
        :title="loginData.parametros.textos.botaoEnviar"
        @click="enviar"
      />
      <ButtonDefault
        v-if="recuperarSenhaAtivo"
        :secundario="true"
        :title="config.configuracaoAcesso.recuperarSenha.parametros.textos.esqueciSenhaTituloNavegacao"
        @click="goToRecuperar"
      />
      <ButtonDefault
        v-if="primeiroAcessoAtivo"
        :secundario="true"
        :title="config.configuracaoAcesso.primeiroAcesso.parametros.textos.tituloNavegacao"
        @click="goToPrimeiroAcesso"
      />
      <ButtonDefault
        v-if="centralDeAjudaAtivo"
        :secundario="true"
        :title="config.configuracaoAcesso.centralDeAjuda.parametros.textos.tituloNavegacao"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import AlertaErro from '@/components/AlertaError/AlertaErro'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ButtonDefault from '@/components/buttons/ButtonDefault'
import TermoDeUsoCombobox from '@/components/TermosDeUso/TermosDeUsoCombobox'
import { renderForm } from '@mobilesaude/form-builder-sdk'

export default {
  name: 'Login',
  components: {
    AlertaErro,
    FuncionalidadeHeader,
    ButtonDefault,
    TermoDeUsoCombobox
  },
  data () {
    return {
      form: {},
      open: false,
      checked: false,
      erro: {
        show: false,
        titulo: 'Erro no preenchimento:',
        descricao: ''
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState('SetupApp', ['config', 'apiAcesso', 'frameId']),
    ...mapGetters('SetupApp', ['estilo']),
    loginData () {
      return this.config.configuracaoAcesso.login
    },
    idTermo () {
      return this.loginData.parametros.idTermosUso
    },
    formBuilderColors () {
      const colors = this.estilo.formBuilder

      if (!colors) {
        return {}
      }

      return {
        primary: colors.corPrincipalFormBuilder,
        errors: colors.corErroFormBuilder,
        alert: colors.corAlertaFormBuilder
      }
    },
    recuperarSenhaAtivo () {
      return (this.config.configuracaoAcesso.recuperarSenha || {}).ativo
    },
    primeiroAcessoAtivo () {
      return (this.config.configuracaoAcesso.primeiroAcesso || {}).ativo
    },
    centralDeAjudaAtivo () {
      return (this.config.configuracaoAcesso.centralDeAjuda || {}).ativo
    }
  },
  methods: {
    ...mapActions('Login', ['setLogin']),
    async init () {
      this.initForm()
    },
    initForm () {
      const formId = this.loginData.parametros.formularios.formLogin

      const id = `form-render`

      // postman > usario unificado > omni usuario > carrega sessão usuãrio
      let params = {
        identifier: id,
        clientKey: this.config.aplicacao.clientKey,
        'idForm': formId,
        'colors': { ...this.formBuilderColors }
      }
      this.form = renderForm(params)
      this.form.on('LOADING', res => {
        this.internalLoading = res
      })
    },
    showError () {
      this.erro.descricao = `<ul>
  <li>CPF</li>
  <li>Senha</li>
</ul>`
      this.erro.show = true
    },
    async enviar () {
      this.erro.show = false

      const formData = await this.form.validateAll()
      if (!formData || !formData.status) {
        return this.showError()
      }

      const payload = formData.data

      // const response = await this.apiAcesso.login.login({ payload, loading: true })
      const response = await this.apiAcesso.login.login({
        payload,
        loading: true,
        handlerErrorIgnore: true
      })

      if (response.status) {
        this.setLogin(response)

        const aceiteTermo = await this.$refs.termoBox.aceitarTermo()

        if (aceiteTermo && aceiteTermo.status) {
          return this.sendLoginMessage(response)
        } else {
          this.erro.descricao = `<ul><li>Falha ao aceitar termos</li></ul>`
          this.erro.show = true
        }
      } else {
        if (response.statusCode === 500) {
          response.message = `Houve uma falha no servidor, tente novamente em instantes.`
        }
        this.erro.descricao = `<ul><li>${response.message}</li></ul>`
        this.erro.show = true
      }
    },
    sendLoginMessage (data) {
      const payload = {
        origin: 'omnichannel',
        client: this.frameId,
        type: 'command',
        command: 'LOGIN',
        data,
        timestamp: Date.now()
      }
      window.parent.postMessage(payload, '*')
    },
    goToRecuperar () {
      this.$router.push({ path: `/137` })
    },
    goToPrimeiroAcesso () {
      this.$router.push({ path: `/134` })
    }
  }
}
</script>

<style scoped>
.login-container {
  max-width: 450px;
  margin: 0 auto;
}

.login-cabecalho {
  letter-spacing: 0;
  color: #333333;
  margin-top: 0;
  margin-bottom: 15px;
}

.login-rodapé {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #333333;
  margin-bottom: 20px;
}
</style>
